<template>
	<div class="headerDiv wrapper">
		<i class="back" @click="back"></i>
		<span>{{pageName}}</span>
	</div>
</template>

<script>
  export default {
    name: 'footerTag',
    props: {
      
    },
	data(){
	  return {
	    pageName: ''
	  }
	},
	methods:{
		back(){
			this.$router.go(-1)
		}
		
	},
	created() {
	  this.pageName = this.$route.meta.title;
	}
  }
</script>